export const CATEGORY_KEY_MAP: Record<string, string> = {
  'self-harm': 'ai_analytics_category_self_harm',
  'self-harm/intent': 'ai_analytics_category_self_harm_intent',
  'self-harm/instructions': 'ai_analytics_category_self_harm_instructions',
  hate: 'ai_analytics_category_hate',
  'hate/threatening': 'ai_analytics_category_hate_threatening',
  harassment: 'ai_analytics_category_harassment',
  'harassment/threatening': 'ai_analytics_category_harassment_threatening',
  violence: 'ai_analytics_category_violence',
  'violence/graphic': 'ai_analytics_category_violence_graphic',
  sexual: 'ai_analytics_category_sexual',
  'sexual/minors': 'ai_analytics_category_sexual_minors',
  illicit: 'ai_analytics_category_illicit',
  'illicit/violent': 'ai_analytics_category_illicit_violent',
};

export const STATUS_KEY_MAP: Record<string, string> = {
  PENDING: 'ai_analytics_inappropriate_use_status_pending',
  REVIEWED: 'ai_analytics_inappropriate_use_status_attended',
  DISMISSED: 'ai_analytics_inappropriate_use_status_dismissed',
};
